import type { SVGAttributes } from 'react';

export function FrenchIcon(props: SVGAttributes<SVGSVGElement>) {
	return (
		<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<g clipPath="url(#clip0_471_2168)">
				<path
					d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
					fill="#F0F0F0"
				/>
				<path
					d="M15.9987 8C15.9987 4.56028 13.8277 1.62793 10.7812 0.497589V15.5024C13.8277 14.3721 15.9987 11.4397 15.9987 8Z"
					fill="#D80027"
				/>
				<path
					d="M0 8C0 11.4397 2.17103 14.3721 5.21741 15.5024V0.497589C2.17103 1.62793 0 4.56028 0 8Z"
					fill="#0052B4"
				/>
			</g>
			<defs>
				<clipPath id="clip0_471_2168">
					<rect width="16" height="16" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
}
